import { Dialog } from "@progress/kendo-react-dialogs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import React, { useEffect, useState } from "react";
import { Label } from "@progress/kendo-react-labels";
import { Input } from "@progress/kendo-react-inputs";
import { filterBy } from "@progress/kendo-data-query";

import "./QualificationTable.scss";

function QualificationForm({ editItem, cancelEdit, ddData, onSubmit }) {
  const {
    qualified,
    primaryOwner,
    secondaryOwner,
    allocatIndicator,
  } = ddData;
  const [allocationIndicatorList, setAllocationIndicator] = useState(ddData["allocatIndicator"]);
  const [modeList, setModeList] = useState(ddData["mode"]);
  const [carrierList, setCarrierList] = useState(ddData["carrier"]);
  const [serviceTypeList, setServiceTypeList] = useState(ddData["serviceType"]);
  const [serviceLevelList, setServiceLevelList] = useState(ddData["serviceLevel"]);
  const [originGeoList, setOriginGeoList] = useState(ddData["originDestgeoData"]);
  const [originCountryList, setOriginCountryList] = useState(ddData["originDestCountryData"]);
  const [originValueList, setOriginPortList] = useState(ddData["originDestPortData"]);
  const [destinationGeoList, setDestinationGeoList] = useState(ddData["originDestgeoData"]);
  const [destinationCountryList, setDestinationCountryList] = useState(ddData["originDestCountryData"]);
  const [destinationValueList, setDestinationPortList] = useState(ddData["originDestPortData"]);
  const [formValues, setFormValues] = useState({
    qualified: "",
    originGeo: "",
    originValue: "",
    originCountry: "",
    destinationGeo: "",
    destinationValue: "",
    destCountry: "",
    servType: "",
    mode: "",
    carrier: "",
    remarks: "",
    validFrom: "",
    validTo: "",
    serviceLevel: "",
    primaryOwner: "",
    secondaryOwner: "",
    allocatIndicator: "",
  });
  const isEditForm = editItem['type'] === 'edit'  ? true : false;

  let setAllocationIndecatorForEdit = (editItem) => {
    if(editItem["qualified"] == 'N' || editItem["qualified"] == 'n'){
      setAllocationIndicator(["N"])
    return 'N';
    } else 
    {
      return editItem["allocatIndicator"];
    }
  }

  useEffect(() => {
    console.log({ddData})
    console.log({editItem})
    if (isEditForm) {
      setFormValues({
        qualified: editItem["qualified"],
        originGeo: ddData["originDestgeoData"].filter(
          (data) => data["value"] === editItem["originGeo"]
        )[0],
        destinationGeo: ddData["originDestgeoData"].filter(
          (data) => data["value"] === editItem["destinationGeo"]
        )[0],
        originValue: ddData["originDestPortData"].filter(
          (data) => data["value"] === editItem["originValue"]
        )[0],
        destinationValue: ddData["originDestPortData"].filter(
          (data) => data["value"] === editItem["destinationValue"]
        )[0],
        servType: ddData["serviceType"].filter(
          (data) => data["value"] === editItem["servType"]
        )[0],
        mode: ddData["mode"].filter(
          (data) => data["value"] === editItem["modeOfTransport"]
        )[0],
        carrier: ddData["carrier"].filter(
          (data) => data["text"] === editItem["scacd"]
        )[0],
        validFrom: editItem["validFrom"],
        validTo: editItem["validTo"],
        remarks: editItem["remarks"],
        originCountry: ddData["originDestCountryData"].filter(
          (data) => data["value"] === editItem["originCountry"]
        )[0],
        destCountry: ddData["originDestCountryData"].filter(
          (data) => data["value"] === editItem["destCountry"]
        )[0],
        serviceLevel: ddData["serviceLevel"].filter(
          (data) => data["value"] === editItem["serviceLevel"]
        )[0],
        primaryOwner: ddData["primaryOwner"].filter(
          (data) => data["text"] === editItem["primaryOwner"]
        )[0],
        secondaryOwner: ddData["secondaryOwner"].filter(
          (data) => data["text"] === editItem["secondaryOwner"]
        )[0],
        allocatIndicator: setAllocationIndecatorForEdit(editItem),
        id: editItem["id"],
        isEditForm
      });

      function setOriginDestinationValue(type, value, odType) {
        let tempData = ddData["originDestination"].map(
          (res) => res[type.toLowerCase()]
        );
        tempData = [...new Set(tempData)];
        // odType === 'origin' ? setOriginList(tempData) : setDestinationList(tempData);
        if (type === "Port") {
          return ddData['originDestination'].find(data => data['port'].split('-')[0].split('_')[1] === value)['port']
        } else if (type === 'Geo') {
          return ddData['originDestination'].find(data => data['geo'] === value)['geo']
        } else if (type === 'Country') {
          return ddData['originDestination'].find(data => data['country'] === value)['country']
        }
      }
    }
  }, []);

  let filterData = (filter, key) => {
    const data = ddData[key].slice();
    return filterBy(data, filter);
  }

const ddPortChange = (eventObject, key) => {
  let dropDownValues = Object.assign( {...formValues}, {[key]: eventObject} );
  let _tempData = [];
  ddData["originDestination"].map(res => {
      if(res.port === eventObject.text){
        _tempData.push(res);
      }
    }
  );

  let _geo = [];
  let _country = [];

  _tempData.map(gcp =>{
    if (!_geo.find((element) => element.text == gcp.geo)){
      _geo.push({text: gcp.geo, value: gcp.geo})
    }
    if (!_country.find((element) => element.text == gcp.country)){
      _country.push({text: gcp.country, value: gcp.country.split('-')[0]})
    }
  })

  _geo = [...new Set(_geo)];
  _country = [...new Set(_country)];
  
  if(key == 'originValue'){
    setOriginGeoList(_geo);
    setOriginCountryList(_country);

    if(_geo.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originGeo: _geo[0] });

    if(_country.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originCountry:  _country[0] });
  } else if(key == 'destinationValue') {
    setDestinationGeoList(_geo);
    setDestinationCountryList(_country);

    if(_geo.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destinationGeo: _geo[0] });

    if(_country.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destCountry:  _country[0] });
    }

  setFormValues({ ...dropDownValues });
};

const ddCountryChange = (eventObject, key) => {
  let dropDownValues = Object.assign( {...formValues}, {[key]: eventObject} );
  let _tempData = [];
  ddData["originDestination"].map(res => {
      if(res.country === eventObject.text){
        _tempData.push(res);
      }
    }
  );

  let _geo = [];
  let _port = [];

  _tempData.map(gcp =>{
    if (!_geo.find((element) => element.text == gcp.geo)){
      _geo.push({text: gcp.geo, value: gcp.geo})
    }
    if (!_port.find((element) => element.text == gcp.port)){
      _port.push({text: gcp.port, value: gcp.port.split('-')[0].split('_')[1], displayText: gcp.port.split('_')[1]})
    }
  })

  _geo = [...new Set(_geo)];
  _port = [...new Set(_port)];

  if(key == 'originCountry'){
    setOriginGeoList(_geo);
    setOriginPortList(_port);

    if(_geo.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originGeo: _geo[0] });

    if(_port.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originValue:  _port[0] });
      else
      dropDownValues = Object.assign( dropDownValues, { originValue:  "" });

  } else if(key == 'destCountry') {
    setDestinationGeoList(_geo);
    setDestinationPortList(_port);
    
    if(_geo.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destinationGeo: _geo[0] });

    if(_port.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destinationValue:  _port[0] });
      else
      dropDownValues = Object.assign( dropDownValues, { destinationValue: "" });
  }

  setFormValues({ ...dropDownValues });
};

const ddGeoChange = (eventObject, key) => {
  let dropDownValues = Object.assign( {...formValues}, {[key]: eventObject} );
  let _tempData = [];
  ddData["originDestination"].map(res => {
      if(res.geo === eventObject.text){
        _tempData.push(res);
      }
    }
  );

  let _country = [];
  let _port = [];

  _tempData.map(gcp =>{
    if (!_country.find((element) => element.text == gcp.country)){
      _country.push({text: gcp.country, value: gcp.country.split('-')[0]})
    }
    if (!_port.find((element) => element.text == gcp.port)){
      _port.push({text: gcp.port, value: gcp.port.split('-')[0].split('_')[1], displayText: gcp.port.split('_')[1]})
    }
  })

  _country = [...new Set(_country)];
  _port = [...new Set(_port)];

  if(key == 'originGeo'){
    setOriginCountryList(_country);
    setOriginPortList(_port);

    if(_country.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originCountry:  _country[0] });

      if(_port.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originValue:  _port[0] });
  } else if(key == 'destinationGeo'){
    setDestinationCountryList(_country);
    setDestinationPortList(_port);

    if(_country.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destCountry:  _country[0] });

      if(_port.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destinationValue:  _port[0] });
  }

  setFormValues({ ...dropDownValues });
};

  const ddOnChange = (event, key) => {
    setFormValues({ ...formValues, [key]: event.target.value });
  };

  const ddOnChangeText = (event, key) => {
    setFormValues({ ...formValues, [key]: event.target.value });
  };

  const handleAllocationAndQualified = (event, key) => {
    let _formValues = Object.assign( {...formValues}, {[key]: event.target.value} );
    let _pairKey = (key === 'qualified') ? 'allocatIndicator' : 'qualified'

    if(key === 'qualified' && event.target.value === 'N'){
      _formValues = Object.assign( {..._formValues}, {[_pairKey]: event.target.value} );
      setAllocationIndicator(["N"]);
    } else if(key === 'qualified' && event.target.value === 'Y'){
      setAllocationIndicator(ddData["allocatIndicator"]);
    }
    
    setFormValues({ ..._formValues });
  };

  function handleSubmit() {
    onSubmit(formValues);
  }

  return (
    <Dialog title={isEditForm? "Edit": "Add Record"} onClose={cancelEdit}>
      <div style={{ width: "25vw", height: "80vh" }}>
        {/* <div>
          <pre>{JSON.stringify(formValues, null, 2)}</pre>
        </div> */}


       {/* Carrier */}
       <div>
          <Label className="LabelClass">
            Carrier <em className="emColor">*</em>
          </Label>
          <DropDownList
            className="dropdownClass"
            filterable={true}
            disabled={isEditForm}
            data={carrierList}
            textField="text"
            onChange={(e) => {
              ddOnChange(e, "carrier");
            }}
            onFilterChange={(event) => {
              setCarrierList(filterData(event.filter, "carrier"));
            }}
            value={formValues["carrier"]}
          />
        </div>
        {/* Mode */}
        <div>
          <Label className="LabelClass">
            Mode <em className="emColor">*</em>
          </Label>
          <DropDownList
          className="dropdownClass"
            filterable={true}
            disabled={isEditForm}
            data={modeList}
            textField="valueText"
            onChange={(e) => {
              ddOnChange(e, "mode");
            }}
            onFilterChange={(event) => {
              setModeList(filterData(event.filter, "mode"));
            }}
            value={formValues["mode"]}
          />
        </div>
        {/* Origin Value */}
        <div>
          <Label className="LabelClass">
            Origin Port <em className="emColor">*</em>
          </Label>
          <DropDownList
          className="dropdownClass"
            filterable={true}
            disabled={isEditForm}
            data={originValueList}
            textField="displayText"
            onChange={(e) => {
              ddPortChange(e.target.value, "originValue");
            }}
            onFilterChange={(event) => {
              setOriginPortList(filterData(event.filter, "originDestPortData"));
            }}
            value={formValues["originValue"]}
          />
        </div>
        {/* Destination Value*/}
        <div>
          <Label className="LabelClass">
            Destination Port <em className="emColor">*</em>
          </Label>
          <DropDownList
          className="dropdownClass"
            filterable={true}
            disabled={isEditForm}
            data={destinationValueList}
            textField="displayText"
            onChange={(e) => {
              ddPortChange(e.target.value, "destinationValue");
            }}
            onFilterChange={(event) => {
              setDestinationPortList(filterData(event.filter, "originDestPortData"));
            }}
            value={formValues["destinationValue"]}
          />
        </div>
        {/* Service Type*/}
        <div>
          <Label className="LabelClass">
            Commodity <em className="emColor">*</em>
          </Label>
          <DropDownList
          className="dropdownClass"
            filterable={true}
            disabled={isEditForm}
            data={serviceTypeList}
            textField="valueText"
            onChange={(e) => {
              ddOnChange(e, "servType");
            }}
            onFilterChange={(event) => {
              setServiceTypeList(filterData(event.filter, "serviceType"));
            }}
            value={formValues["servType"]}
          />
        </div>
        {/* Qualified */}
        <div>
          <Label className="LabelClass">
            Qualified <em className="emColor">*</em>
          </Label>
          <DropDownList
          className="dropdownClass"
            data={qualified}
            onChange={(e) => {
              handleAllocationAndQualified(e, "qualified");
            }}
            value={formValues["qualified"]}
          />
        </div>
        {/* Origin Type */}
        <div>
          <Label className="LabelClass">
            Origin Geo <em className="emColor">*</em>
          </Label>
          <DropDownList
          className="dropdownClass"
            data={originGeoList}
            textField="text"
            onChange={(e) => {
              ddGeoChange(e.target.value, "originGeo");
            }}
            onFilterChange={(event) => {
              setOriginGeoList(filterData(event.filter, "originDestgeoData"));
            }}
            value={formValues["originGeo"]}
          />
        </div>
        {/* Origin Country */}
        <div>
          <Label className="LabelClass">Origin Country / Region <em className="emColor">*</em></Label>
          <DropDownList
          className="dropdownClass"
            filterable={true}
            data={originCountryList}
            textField="text"
            onChange={(e) => {
              ddCountryChange(e.target.value, "originCountry");
            }}
            onFilterChange={(event) => {
              setOriginCountryList(filterData(event.filter, "originDestCountryData"));
            }}
            value={formValues["originCountry"]}
          />
        </div>
        {/* Destination Type */}
        <div>
          <Label className="LabelClass">
            Destination Geo <em className="emColor">*</em>
          </Label>
          <DropDownList
          className="dropdownClass"
            data={destinationGeoList}
            textField="text"
            onChange={(e) => {
              ddGeoChange(e.target.value, "destinationGeo");
            }}
            onFilterChange={(event) => {
              setDestinationGeoList(filterData(event.filter, "originDestgeoData"));
            }}
            value={formValues["destinationGeo"]}
          />
        </div>
        {/* Destination Country */}
        <div>
          <Label className="LabelClass">Destination Country / Region <em className="emColor">*</em></Label>
          <DropDownList
          className="dropdownClass"
            filterable={true}
            data={destinationCountryList}
            textField="text"
            onChange={(e) => {
              ddCountryChange(e.target.value, "destCountry");
            }}
            onFilterChange={(event) => {
              setDestinationCountryList(
                filterData(event.filter, "originDestCountryData")
              );
            }}
            value={formValues["destCountry"]}
          />
        </div>
        {/* Service Level */}
        <div>
          <Label className="LabelClass">Service Level <em className="emColor">*</em></Label>
          <DropDownList
          className="dropdownClass"
            filterable={true}
            data={serviceLevelList}
            textField="valueText"
            onChange={(e) => {
              ddOnChange(e, "serviceLevel");
            }}
            onFilterChange={(event) => {
              setServiceLevelList(
                filterData(event.filter, "serviceLevel")
              );
            }}
            value={formValues["serviceLevel"]}
            disabled={isEditForm}

          />
        </div>
        {/* Primary Owner */}
        <div>
          <Label className="LabelClass">Primary Owner <em className="emColor">*</em></Label>
          <DropDownList
          className="dropdownClass"
            data={primaryOwner}
            textField="text"
            onChange={(e) => {
              ddOnChangeText(e, "primaryOwner");
            }}
            value={formValues["primaryOwner"]}
          />
        </div>
        {/* Secondary Owner */}
        <div>
          <Label className="LabelClass">Secondary Owner</Label>
          <DropDownList
          className="dropdownClass"
            data={secondaryOwner}
            textField="text"
            onChange={(e) => {
              ddOnChangeText(e, "secondaryOwner");
            }}
            value={formValues["secondaryOwner"]}
          />
        </div>
        {/* Allocation Indicator */}
        <div>
          <Label className="LabelClass">Allocation Indicator <em className="emColor">*</em></Label>
          <DropDownList
          className="dropdownClass"
            data={allocationIndicatorList}
            onChange={(e) => {
              handleAllocationAndQualified(e, "allocatIndicator");
            }}
            value={formValues["allocatIndicator"]}
          />
        </div>
        {/* Remarks */}
        <div>
          <Label className="LabelClass">Remarks</Label>
          <Input
          className="dropdownClass"
            onChange={(e) => {
              ddOnChange(e, "remarks");
            }}
            value={formValues["remarks"]}
          />
        </div>
        {isEditForm && (
          <>
            <div
              className="pb-3"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <b className="LabelClass">Valid From</b>
              <span style={{ paddingRight: "45%",color:"black" }}>
                {formValues["validFrom"]}
              </span>
            </div>

            <div
              className="pb-3"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <b className="LabelClass">Valid To</b>
              <span style={{ paddingRight: "45%",color:"black" }}>
                {formValues["validTo"]}
              </span>
            </div>
          </>
        )}
        <div className="k-form-buttons" style={{ paddingBottom: "15px", paddingTop:"15px" }}>
          <button
            type={"submit"}
            onClick={handleSubmit}
            className="submitButton"
          >
            {isEditForm? "Update": "Submit"}
          </button>
          <button
            type={"submit"}
            onClick={cancelEdit}
            className="k-button k-button-icontext rejectbtn"
          >
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default QualificationForm;
